export const RAZORPAY_CALLBACK_URL = "/nodeapi/razorpay";

export const STATUS = {
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
    LOADING: "LOADING",
};

export const NORMAL_BANK_PRIORITY = 0;

export const UPI_ERROR_MESSAGE = {
    INVALID:  "UPI ADDRESS NOT VALID",
    ERROR: "SOMETHING WENT WRONG",
};

export const UPI_INTENT_EXPERIMENT = {
    EXPAND_UPI_AND_HIDE_GPAY: "EXPAND_UPI_AND_HIDE_GPAY",
    OLD_UPI_FLOW: "OLD_UPI_FLOW",
};

export const FLOW = {
  WALLET: "vault",
  GIFTCARD: "giftcard",
};

export const SELF_LOAD = "selfLoad";

export const PAYTM_AUTO_DEBIT = "paytmAutoDebit";

export const PRIVE_WIDGET_EXPERIMENT = "N_PV";

export const SEMI_CLOSED_WALLET_STATES = {
    NOT_VERIFIED: "not verified",
    VERIFIED: "verified",
};

export const WALLET_STATES = {
    CLOSED: "closed",
    SEMI_CLOSED: "semi closed",
};
export const VERNACULAR_LANG_COOKIE_NAME = "lang";

export const ZEST_MONEY_EXPERIMENT = {
  VARIANT_1: "Z_V_1",
  VARIANT_2: "Z_V_2",
  VISIBILITY: "Z_VISIBILITY",
};

export const ERROR_BOUNDARY_DEFAULT_MESSAGES = {
  ZEST: "Failed to load Zest Money section",
  SHOP_NOW_PAY_LATER: "Failed to load Shop Now Pay Later section",
  SIMPL: "Failed to load Simpl section",
};
export const OTHER_UPI = "Other UPI";

export const CC_FORM_FIELD = {
  CARD_NUMBER: "number",
  EXPIRY_MONTH: "expiryMonth",
  EXPIRY_YEAR: "expiryYear",
  CVV: "cvv",
};

export const CARD_TYPES = {
    VISA: "VISA",
    RUPAY: "RUPAY",
    LASER: "LASER",
    DISCOVER: "DISCOVER",
    SBIMAESTRO: "SBIMAESTRO",
    MAESTRO: "MAESTRO",
    MASTERCARD: "MASTERCARD",
    AMEX: "AMEX",
    AMEX_2: "American Express",
    DINERS: "DINERS",
    JCB: "JCB",
    ENROUTE: "ENROUTE",
    INVALID: "INVALID",
    WESTERN_UNION_ICON: "WESTERN UNION",
    PAYPAL_ICON: "PAYPAL",
  };

export const SIMPL_FLOW = {
  NOT_ELIGIBLE: "7000",
  BILL_PENDING: "7001",
  INSUFFICIENT_CREDIT: "7002",
  RELINK_AND_PAY: "7003",
  SIMPL_NOT_AVAILABLE: "7004",
  ELIGIBLE: "7005",
  LINK_AND_PAY: "7007",
  ALREADY_LINKED: "7011",
};

export const EDD_VARIANT = {
  VARIANT_A: "A",
};

export const EDD_COOKIE_NAME = {
  EXP_EDD_DELIVERY_WIDGET: "EXP_EDD_DELIVERY_WIDGET",
};

export const LOAD_MONEY_SUB_TYPES = {
  SELF_LOAD: "selfLoad",
};

export const LOADER_TIME_OUT_STATE = {
  LOADER_TIME_OUT: true,
};
